import { render, staticRenderFns } from "./create-handover-session.vue?vue&type=template&id=3222b929&"
import script from "./create-handover-session.vue?vue&type=script&lang=ts&"
export * from "./create-handover-session.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports